import { useState, useEffect, Fragment } from "react";
import styles from "../devicebackup.module.scss";
import { Button, Card, Table, Popconfirm, message, Tooltip, Space } from "antd";
import { useTranslation } from "react-i18next";
import { AiOutlineIssuesClose } from "react-icons/ai";
import { DeleteOutlined } from "@ant-design/icons";
import { useAppSelector, useAppDispatch } from "store/hook";
import { setActionStatusList } from "../store/upgradeSlice";
import { RiDeleteBin5Line } from "react-icons/ri";
import { TimestampToDate } from "../../../Utility/Fetch";
// import { useIdleTimer } from "react-idle-timer";
import { useSearchColumn } from "./utils";
import { useActionList, useDelectionAction } from "../queries";
import { useDeviceLocation } from "Components/Topology/queries";
import { useCustomerInf } from "Components/Management/queries";
import { useIdentity } from "Components/Topology/queries";
import { useQueryClient } from "react-query";
import { useUpdateDeviceAction } from "../queries";
import ActionListSummary from "./ActionStatusF_SummaryList";
// import { useLogout } from "Components/Login/quires";
import AutoRefresh from "Components/Shared/AutoRefresh";
import Refresh from "Components/Shared/Refresh";
import moment from "moment";

const ActionStatusC = () => {
  const { level, stateCid, loginCid, time_zone } = useAppSelector((state) => state.global);
  const { modelList } = useAppSelector((state) => state.upgrade);
  const disp = useAppDispatch();
  const [event, setEvent] = useState([]);
  const [count, setCount] = useState(0);
  const [statusResult, setStatusResult] = useState<any>({});
  const [stateList, setStateList] = useState<string[]>([]);
  const [statusResultByCid, setStatusResultByCid] = useState<any>({});
  const { t } = useTranslation();
  // const [AutoRefresh, setAutoRefresh] = useState(false);
  // const { getRemainingTime } = useIdleTimer({
  //   timeout: 300000,
  // });
  const actionListSummaryProps = { level, event, statusResult, statusResultByCid };
  const getColumnSearchProps = useSearchColumn();
  const { data: identity } = useIdentity(level, stateCid, loginCid);
  const { data: actionList, isFetching: actionListFetcisFetching } = useActionList(level, stateCid, loginCid);
  const { data: deviceLocation, isFetching: deviceLocationFetcisFetching } = useDeviceLocation(
    level,
    stateCid,
    loginCid
  );
  const { data: customerInf, isFetching: customerInfFetcisFetching } = useCustomerInf(level, stateCid, loginCid);
  const loading = actionListFetcisFetching || deviceLocationFetcisFetching || customerInfFetcisFetching;
  // const fetching = actionListFetching || deviceLocationFetching || customerInfFetching
  const { mutate: deleteActiton } = useDelectionAction(stateCid);
  const { mutateAsync: retryDeviceAction } = useUpdateDeviceAction(stateCid);
  const queryClient = useQueryClient();
  // const { mutate: logoutMutatiion } = useLogout();
  const forbiddenLevel = level === "get" || (level === "super_super" && stateCid === "");

  // 用來判斷該 device 的 health，offline 時不能 retry
  const nodeInf: any = [];
  identity?.response?.device_identity?.map((item: any) => {
    nodeInf.push(item.nodeInf);
  });

  useEffect(() => {
    if (actionList && deviceLocation && customerInf) {
      let CityResponse = deviceLocation.response?.city?.data;
      let customerName: any = {};
      customerInf.response.forEach((item: any) => {
        let cid = item.cid;
        customerName[cid] = item.inf_list.company;
      });

      let responseData: any = [];
      let StatusList: string[] = [];
      let statusResultByCid: any = {};
      // count用來儲存結果資料
      let counts: any = {};
      let StateArray: any = new Set();
      // let modelList: any = new Set();

      if (actionList.response?.bck_rst_upg) {
        const reversedList = [...actionList.response.bck_rst_upg].reverse();

        responseData = reversedList.map((item: any, index: number) => {
          StatusList.push(`${item.state}(${item.action})`);
          StateArray.add(item.state);
          // modelList.add(item.model);
          let companyName = customerName[item.cid];
          if (!statusResultByCid[companyName]) {
            statusResultByCid[companyName] = [];
            statusResultByCid[companyName].push(`${item.state}(${item.action})`);
          } else {
            statusResultByCid[companyName].push(`${item.state}(${item.action})`);
          }

          let city = CityResponse.filter((i: any) => i.id === item.id);

          return {
            fileName: item.name,
            device_name: item.device_name,
            appearID: item.device_name !== "" ? item.device_name : item.id,
            action: item.action,
            key: index,
            model: item.model,
            command_state: item.command_state,
            state: item.state,
            id: item.id,
            time: item.utc === 0 ? moment().unix() : item.utc,
            city: city?.[0]?.city,
          };
        });

        StateArray = Array.from(StateArray);
        setStateList(StateArray);
        // 利用for迴圈遍歷arr並分析
        for (var i = 0; i < StatusList.length; i++) {
          // 將StatusList[i]值存於num中
          let num = StatusList[i];
          // 比較counts物件，如相同則該物件存值+1，如不同則存值設為1
          counts[num] = counts[num] ? counts[num] + 1 : 1;
        }
        //給super_super參考用  用不同cid區分狀態
        Object.keys(statusResultByCid).forEach((item) => {
          let counts: any = { TOTAL: "" };
          statusResultByCid[item].forEach((status: string) => {
            counts[status] = counts[status] ? counts[status] + 1 : 1;
          });
          counts["TOTAL"] = Object.values(counts).reduce((a, b) => {
            return Number(a) + Number(b);
          });
          statusResultByCid[item] = counts;
        });
        setStatusResultByCid(statusResultByCid);
      } else {
        responseData = [];
      }
      setStatusResult(counts);
      if (JSON.stringify(responseData) === JSON.stringify(event)) {
        return;
      }
      setEvent(responseData);
      disp(setActionStatusList(responseData));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actionList, deviceLocation, customerInf]);

  const Retry = ({ ...values }: any) => {
    values["Device_ID"] = [values.id];
    values["action"] = values.action.toLowerCase();
    retryDeviceAction({ level, stateCid, loginCid, time_zone, values })
      .then(() => {
        message.success(t("ISMS.Success"));
      })
      .catch(() => {
        message.error(t("ISMS.Fail"));
      });
  };

  const columns = [
    {
      title: t("ISMS.Location"),
      dataIndex: "city",
      ...getColumnSearchProps("city"),
      render: (_: string, record: any) => (record.city ? record.city : ""),
    },
    {
      title: t("ISMS.Device"),
      dataIndex: "appearID",
      ...getColumnSearchProps("appearID"),
    },
    {
      title: t("ISMS.Model"),
      dataIndex: "model",
      responsive: ["md"],
      filters: modelList.map((item: any) => {
        return { text: item, value: item };
      }),
      onFilter: (value: string, record: any) => record.model === value,
    },
    {
      title: t("ISMS.Action"),
      dataIndex: "action",
      filters: [
        { text: "UPGRADE", value: "UPGRADE" },
        { text: "BACKUP", value: "BACKUP" },
        { text: "RESTORE", value: "RESTORE" },
      ],
      onFilter: (value: string, record: any) => record.action === value,
      render: (text: string) => text.toUpperCase(),
    },
    {
      title: t("ISMS.FileName"),
      ...getColumnSearchProps("fileName"),
      dataIndex: "fileName",
      responsive: ["md"],
    },
    {
      title: t("ISMS.Time"),
      dataIndex: "time",
      sorter: (a: any, b: any) => a.time - b.time,
      sortDirections: ["descend", "ascend"],
      render: (text: number) => TimestampToDate(text * 1000, time_zone),
    },
    {
      title: t("ISMS.Status"),
      dataIndex: "state",
      filters: stateList.map((item: any) => {
        return { text: item, value: item };
      }),
      onFilter: (value: string, record: any) => record.state === value,
    },

    {
      title: t("ISMS.Action"),
      dataIndex: "History",
      render: (_: string, record: any, index: number) => {
        // state 不能 retry 的情況
        const disable_retry_state =
          record.state === "WAITING" ||
          record.state === "FILE_DOWNLOADING" ||
          record.state === "FILE_DOWNLOAD" ||
          record.state === "COMMAND_ERROR" ||
          record.state === "FILE_ERROR";

        // health 不能 retry 的情況
        let disable_retry_health;
        nodeInf.map((item: any) => {
          if (item.id === record.id) {
            disable_retry_health = item.health === "offline";
          } else {
            return;
          }
        });
        return (
          <Fragment>
            <Tooltip title={t("ISMS.Delete this action")}>
              <Popconfirm
                title={t("ISMS.Sure to delete?")}
                okText={t("ISMS.OK")}
                cancelText={t("ISMS.Cancel")}
                disabled={forbiddenLevel}
                onConfirm={() => {
                  const param = { stateCid, id: record.id };
                  deleteActiton(param);
                }}
              >
                <Button
                  key={index}
                  icon={<RiDeleteBin5Line />}
                  type="text"
                  style={{ padding: "4px" }}
                  disabled={forbiddenLevel}
                >
                  {/* <RiDeleteBin5Line className={styles.DeleteIcon} /> */}
                </Button>
              </Popconfirm>
            </Tooltip>
            <Tooltip title={t("ISMS.Retry this action")}>
              <Popconfirm
                title={t("ISMS.Sure to retry?")}
                okText={t("ISMS.OK")}
                cancelText={t("ISMS.Cancel")}
                disabled={forbiddenLevel}
                onConfirm={() => {
                  Retry(record);
                }}
              >
                <Button
                  key={index}
                  icon={<AiOutlineIssuesClose />}
                  type="text"
                  style={{ padding: "4px" }}
                  disabled={forbiddenLevel || disable_retry_state || disable_retry_health}
                >
                  {/* <AiOutlineIssuesClose className={styles.DeleteIcon} /> */}
                </Button>
              </Popconfirm>
            </Tooltip>
          </Fragment>
        );
      },
    },
  ];

  return (
    <Card
      title={t("ISMS.Action Status")}
      bordered={true}
      extra={
        <Space size={1}>
          <Refresh queriesArray={["actionList", "repositoryList", "identity"]} />

          <AutoRefresh queriesArray={["actionList", "repositoryList", "identity"]} />

          <Tooltip title={t("ISMS.ClearAll")}>
            <Popconfirm
              title={t("ISMS.Sure to delete?")}
              okText={t("ISMS.OK")}
              cancelText={t("ISMS.Cancel")}
              disabled={forbiddenLevel}
              onConfirm={() => {
                const param = { stateCid, id: "ClearAll" };
                deleteActiton(param);
              }}
            >
              <Button icon={<DeleteOutlined />} disabled={forbiddenLevel}></Button>
            </Popconfirm>
          </Tooltip>
        </Space>
      }
    >
      <ActionListSummary {...actionListSummaryProps} />
      <Table
        //@ts-ignore
        columns={columns}
        dataSource={event}
        pagination={{ showSizeChanger: true }}
        className={styles.table}
        loading={count === 0 && loading}
      />
    </Card>
  );
};

export default ActionStatusC;
